import React, { useState } from "react";
import "../../../Styles/MobileViewPersonalizedHealthcare.scss";
import personalizeImg from "../../../Assests/MobileViewAboutUs/PersonalizedHealthcareImg.png";
import { Link } from "react-router-dom";
import ReusableModal from "../../../Utils/ReusableModel";
import AboutVizzhyVideo from "../../../Utils/Modal/AboutVizzhyVideo";

function MobileViewPersonalizedHealthcare() {

 const [showVideoModal, setShowVideoModal] = useState(false);
  const openVideoModal = () => setShowVideoModal(true);
  const closeVideoModal = () => setShowVideoModal(false);
  return (
    <div className="MobileViewPersonalizedHealthcare  mt-5 pt-3">
      <div>
        <div class="MobileViewPersonalizedHealthcare-container">
          <img src={personalizeImg} alt="Snow" style={{ width: "100%" }} />
          {/* <div class="bottom-left">Bottom Left</div> */}
          {/* <div class="top-left">Top Left</div> */}
          {/* <div class="top-right">Top Right</div> */}
          {/* <div class="bottom-right">Bottom Right</div> */}
          <div
            class="MobileViewPersonalizedHealthcare-centered fw-bold text-start"
            style={{ fontSize: "2.1rem", lineHeight: "1", color: "#2D143D" }}
          >
            <div>Redefining</div>
            <div>Personalized</div>
            <div>
              Healthcare<sub className="primary-color">•</sub>
            </div>
          </div>

          <div  class="MobileViewPersonalizedHealthcare-centered-para mt-2">
            <div className="text-start" style={{fontSize:".8rem"}}>
            The world’s first Gen AI & Multi-Omics-based Deep Phenotyping
            Program, transforming healthcare with precision P5 medicine.
            </div>

            <div className="mt-4">
            <Link to="/contact" className="forgot-link ">
            <div
              className="d-flex primary-btn py-2  justify-content-center align-items-center   fw-bold contact-us"
              style={{width:"45%"}}
            >
              <div>Contact Us</div>
              <span class="material-symbols-outlined ms-1">
                arrow_right_alt
              </span>
            </div>
          </Link>
            </div>
          
          </div>

          <div className="MobileViewPersonalizedHealthcare-centered-video  w-100 ">
 

        <div className="d-flex justify-content-center py-4 rounded-3  shadow-lg m-auto cursor-pointer " style={{width:"90%"}} onClick={openVideoModal}>
            <div className="personalized-text-gradient fw-bold">Watch the Company overview</div>
        
        <span
              class="material-symbols-outlined ms-5 primary-color"
            //   style={{ fontSize: "70px" }}
            >
              play_circle
            </span>
        </div>
          </div>


        </div>
      </div>

      <ReusableModal
        data="modal-xl"
        showModal={showVideoModal}
        closeModal={closeVideoModal}
        content={
          <AboutVizzhyVideo
            isOpen={showVideoModal}
            closeModal={closeVideoModal}
          />
        }
      />
    </div>
  );
}

export default MobileViewPersonalizedHealthcare;
